import LoadingButton from "@mui/lab/LoadingButton";
import { Card, Stack } from "@mui/material";
import FormProvider, { RHFTextField } from "src/components/hook-form";
import RHFEditor from "src/components/hook-form/rhf-editor";
import { RHFUploadMultiFile } from "src/components/hook-form/rhf-upload";
import { useMyDataStore } from "src/store/me/me.store";

interface PromoterTermsFormProps {
    hook: any;
}

export default function PromoterTermsForm({ hook }: PromoterTermsFormProps) {
    const permissions = useMyDataStore((state) => state.me?.cnAdminInfo?.permissions?.promoters)

    return (
        <Card>
            <FormProvider methods={hook.methods} onSubmit={hook.onSubmit}>
                <Stack
                    spacing={2}
                    sx={{
                        p: 4,
                    }}
                >
                    <RHFTextField name="title" label="Título" />
                    <RHFTextField name="version" label="Versão" disabled />
                    <RHFEditor name="contentHtml" label="Conteúdo" />
                    <RHFUploadMultiFile
                        name="content"
                        showPreview={false}
                        onRemove={hook.handleRemove}
                        onRemoveAll={hook.handleRemoveAll}
                        onDrop={hook.handleDropMultiple}
                    />
                    <Stack
                        mt={4}
                        direction="row"
                        sx={{
                            justifyContent: 'flex-end',
                        }}
                    >
                        <LoadingButton type="submit" loading={hook.isSubmitting} variant="soft" disabled={!permissions?.update}>
                            Salvar termos
                        </LoadingButton>
                    </Stack>
                </Stack>
            </FormProvider>
        </Card>
    )
}